import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import axiosInstance from "../axiosConfig";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import moment from 'moment';

const LiveLocationMap = () => {
    const [locations, setLocations] = useState([]);
    const [center, setCenter] = useState([28.6139, 77.2090]);  // Default to a central location (Delhi)

    useEffect(() => {
        fetchLiveLocations();
        const interval = setInterval(fetchLiveLocations, 10000); // Refresh every 10 sec
        return () => clearInterval(interval);
    }, []);

    const fetchLiveLocations = async () => {
        try {
            const response = await axiosInstance.get("location/live/all/"); // Fetch live locations of all users
            console.log("Live Locations:", response.data);
            setLocations(response.data);

            if (response.data.length > 0) {
                // Optionally center the map to the first user, or you can leave this as a default
                setCenter([response.data[0].latitude, response.data[0].longitude]); 
            }
        } catch (error) {
            console.error("Failed to fetch live locations:", error);
        }
    };

    return (
        <MapContainer center={center} zoom={15} style={{ height: "500px", width: "100%" }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {locations.map((loc) => (
                <Marker
                    key={loc.user_id}  // Use a unique identifier like user_id
                    position={[loc.latitude, loc.longitude]}
                    icon={L.icon({
                        iconUrl: loc.is_out_of_office
                            ? "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Red_circle.svg/1200px-Red_circle.svg.png" // Red Icon for out-of-office
                            : "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png", // Default blue marker
                        iconSize: [25, 25],
                    })}
                >
                    <Popup>
                        <strong>User:</strong> {loc.user_name} ({loc.employee_code}) <br />
                        <strong>Latitude:</strong> {loc.latitude} <br />
                        <strong>Longitude:</strong> {loc.longitude} <br />
                        <strong>Last Updated:</strong> {moment(loc.updated_at).format('YYYY-MM-DD hh:mm A')}
                        {loc.is_out_of_office ? (
                            <span style={{ color: "red", fontWeight: "bold" }}>🚨 Out of Office 🚨</span>
                        ) : (
                            <span style={{ color: "green" }}>✔ Inside Office</span>
                        )}
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
};

export default LiveLocationMap;
